import { render } from "./ResellerAccountId.vue?vue&type=template&id=1d77e372"
import script from "./ResellerAccountId.vue?vue&type=script&lang=js"
export * from "./ResellerAccountId.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__